import { Link } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h4 className="text-lg font-heading text-background-50 mb-4">
                <Link to="/">天堂影院</Link>
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                高清电影在线看，免费电影网站汇聚最新电影在线观看、电影大全，高清不缓冲流畅在线观看，极速播放无广告，享受极致观影体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">电影分类</h4>
              <ul className="space-y-2">
                {movieCategories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/scifi" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    科幻电影
                  </Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    动作电影
                  </Link>
                </li>
                <li>
                  <Link to="/category/comedy" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    喜剧电影
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">联系方式</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-mail-line text-background-400 mt-0.5"></i>
                  <span className="text-sm text-background-400">contact@ttcinema.com</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-phone-line text-background-400 mt-0.5"></i>
                  <span className="text-sm text-background-400">400-888-8888</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-background-400 mt-0.5"></i>
                  <span className="text-sm text-background-400">北京市朝阳区光华路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 天堂影院 t tcinema.com 版权所有 | 高清电影在线看，免费电影网站
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}